import { RESOURCE_MODULE_IDS } from "config/constants";

const GENERAL_HEADERS_TABLE_LIST = [
    {
        title: "Finaliza"
    },
    {
        title: "Detalles"
    },
    {
        title: "Fecha"
    },
    {
        title: "Hora"
    }
];
export const HEADERS_TABLE_LIST = {
    LIBRARY: [
        ...GENERAL_HEADERS_TABLE_LIST
    ],
    LIBRARY_WITH_PENALIZE_DAYS: [
        {
            title: "Días de sanción"
        },
        ...GENERAL_HEADERS_TABLE_LIST
    ],
    SPORTS_CENTER: [...GENERAL_HEADERS_TABLE_LIST]
};